import { httpPost, httpDownload } from '../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL, REPORT_COLUMN_MODULE } from '../../../constants/external-constants';
import {
    getRateCard,
    setRateCardError,
    setRateCardColSearchStr,
    sortRateCardItems,
    setRateCardPageSize,
    setRateCardFilter,
    applyRateCardFilter,
    setDefaultRateCard,
} from "../../../constants/model-reducers/external/finance/rate-card.settings";
import { convertToFormatLocalDate } from '../../../utils/helpers.utils';
const defaultState = () => ({
    isRateCardLoaded: false,
    isRateCardError: false,
    rateCardItems: DEFAULT_TABLE_RESULT_MODEL,
    rateCardColSort: '',
    rateCardIsSortedAsc: false,
    rateCardTableFilterList: [],
    rateCardTableFilterApply: false,

});
const initialState = defaultState();
export const rateCardActions = {
    setDefaultRateCard: () => async (dispatch, state) => {
        dispatch({
            type: setDefaultRateCard,
            rateCardItems: DEFAULT_TABLE_RESULT_MODEL
        });
    },
    getRateCard: (pageIndex = 0, pageUnmount = false) => async (dispatch, state) => {
        const { Headers, Pagination } = state().rateCard.rateCardItems;
        const { rateCardIsSortedAsc, rateCardColSort, rateCardTableFilterList, rateCardTableFilterApply } = state().rateCard;

        var userId = sessionStorage.getItem('UserID');
        const headersToSend = pageUnmount ? {} : { ...Headers };

        try {
            var data = {
                PageFilter: {
                    PageIndex: pageIndex !== undefined ? pageIndex : 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: headersToSend,
                SortedColumnName: rateCardColSort,
                IsSortAscending: rateCardIsSortedAsc,
                TableFilterList: rateCardTableFilterList,
                ApplyFilter: rateCardTableFilterApply,
            };
            var rateCardItems = await httpPost('external/finance/getRateCardItems', data);
            dispatch({
                type: getRateCard,
                rateCardItems: Object.keys(rateCardItems).length > 0 ? rateCardItems : DEFAULT_TABLE_RESULT_MODEL,
                isRateCardLoaded: true,
                isRateCardError: false
            });
        }
        catch (e) {
            dispatch({
                type: setRateCardError,
                isRateCardError: true,
                isRateCardLoaded: false
            });
        }
    },
    setRateCardColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { rateCardItems } = state().rateCard;
        var rateCardItemsUpd = {
            ...rateCardItems,
            "Headers": {
                ...rateCardItems.Headers,
                [key]: {
                    ...rateCardItems.Headers[key],
                    searchString: val
                }
            }
        }
        dispatch({
            type: setRateCardColSearchStr,
            data: rateCardItemsUpd,
            isRateCardError: false,
            isRateCardLoaded: true
        });
    },
    sortRateCardItems: (columnClicked, isSortedAsc) => async (dispatch, state) => {
        const { PageNumber, PageSizes } = state().rateCard.rateCardItems.Pagination;
        const { rateCardItems, rateCardTableFilterList, rateCardTableFilterApply } = state().rateCard;

        var data = {
            PageFilter: {
                PageIndex: PageNumber !== undefined ? PageNumber : 0,
                PageSize: rateCardItems.Pagination.PerPage,
                PageSizes: PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...rateCardItems.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc,
            TableFilterList: rateCardTableFilterList,
            ApplyFilter: rateCardTableFilterApply,
        };
        var resRateCardItems = await httpPost('external/finance/getRateCardItems', data);
        if (resRateCardItems.ok === false) {
            dispatch({
                type: setRateCardError,
                isRateCardError: true,
                isRateCardLoaded: false
            });
        } else {
            dispatch({
                type: sortRateCardItems,
                rateCardItems: Object.keys(resRateCardItems).length > 0 ? resRateCardItems : DEFAULT_TABLE_RESULT_MODEL,
                rateCardColSort: columnClicked,
                rateCardIsSortedAsc: isSortedAsc,
                isRateCardLoaded: true
            });
        }
    },


    extractRateCard: () => async (dispatch, state) => {
        const { Headers } = state().rateCard.rateCardItems;
        const { rateCardColSort, rateCardIsSortedAsc, rateCardTableFilterApply, rateCardTableFilterList } = state().rateCard;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat } = state().adminSetting;
        var filename = `ATEM ${dealName} Rate Card Extract – ${convertToFormatLocalDate(new Date(), activeDateFormat.Name).replaceAll('/', '-')}`;
        var data = {
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: rateCardColSort,
            IsSortAscending: rateCardIsSortedAsc,
            FileName: filename,
            TableFilterList: rateCardTableFilterList,
            ApplyFilter: rateCardTableFilterApply,



        };
        httpDownload('external/finance/getAllRateCardExtractItems', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },



    resizeRateCardPage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setRateCardPageSize,
            pageSize: parseInt(pageSize),
        });
    },
    addRateCardFilter: (tableFilter) => (dispatch, state) => {
        const { rateCardTableFilterList } = state().rateCard;
        var filterList = [...rateCardTableFilterList, tableFilter];
        dispatch({
            type: setRateCardFilter,
            filterList: filterList
        })
    },
    removeRateCardFilter: (removeIndex) => (dispatch, state) => {
        const { rateCardTableFilterList } = state().rateCard;
        var filterList = rateCardTableFilterList.filter((item, index) => {
            return index !== removeIndex;
        });
        dispatch({
            type: setRateCardFilter,
            filterList: filterList
        })
    },
    applyRateCardFilter: (isApply) => (dispatch, state) => {
        const { rateCardTableFilterList } = state().rateCard;
        dispatch({
            type: applyRateCardFilter,
            applyFilter: isApply,
            filterList: isApply ? rateCardTableFilterList : []
        });
    },
};
export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case getRateCard:
            return {
                ...state,
                rateCardItems: action.rateCardItems,
                isRateCardLoaded: action.isRateCardLoaded,
                isRateCardError: action.isRateCardError
            };
        case setRateCardError:
            return {
                ...state,
                isRateCardError: action.isRateCardError,
                isRateCardLoaded: action.isRateCardLoaded
            }
        case setRateCardColSearchStr:
            return {
                ...state,
                rateCardItems: action.data,
                isRateCardLoaded: action.isRateCardLoaded,
                isRateCardError: action.isRateCardError
            }
        case sortRateCardItems:
            return {
                ...state,
                rateCardItems: action.rateCardItems,
                rateCardColSort: action.rateCardColSort,
                rateCardIsSortedAsc: action.rateCardIsSortedAsc,
                isRateCardLoaded: action.isRateCardLoaded
            }
        case setRateCardPageSize:
            return {
                ...state,
                rateCardItems: {
                    ...state.rateCardItems,
                    Pagination: {
                        ...state.rateCardItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setRateCardFilter:
            return {
                ...state,
                rateCardTableFilterList: action.filterList
            }
        case applyRateCardFilter:
            return {
                ...state,
                rateCardTableFilterApply: action.applyFilter,
                rateCardTableFilterList: action.filterList
            }
        case setDefaultRateCard:
            return initialState;
        default:
            return state;
    }
};